import {L} from "../lt-ng/landcare-toolkit";
import {LTMap} from "../lt-ng/lt-directives";
import {_F} from "./func";
import {ImageWMS, TileWMS, WMTS} from "ol/source";
import {GeoJSON} from "ol/format";
import {Feature, Map as OlMap} from "ol";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {Coordinate} from "ol/coordinate";
import {Extent, intersects} from "ol/extent";
import {GeoJSONFeature, GeoJSONFeatureCollection} from "ol/format/GeoJSON";
import {color as Color} from "d3-color";
import {pageExtent} from "./print/page";
import {Geometry} from "ol/geom";
import {Type} from "ol/geom/Geometry.js";


export module MapFishPrint {
	import IQueryString = LTMap.IQueryString;
	import getVisibleLayers = L.tree.getVisibleLayers;
	import uniqueBy = _F.uniqueBy;

	export interface ILayout {
		name	: string;
		rotation: boolean;
		map 	: {
			height	: number;
			width	: number;
		}
	}

	export interface INameValue {
		name : string;
		value : string;
	}

	export interface IName {
		name : string;
	}

	export interface IPrintCapabilities {
		app			: string;
		createURL	: string;
		dpis		: INameValue[];
		layouts		: ILayout[];
		outputFormats: IName[];
		printURL	: string;
		scales		: INameValue[]
	}

	export interface IMapFishRequest {
		layout: 		string;
		srs:			string;
		units:			string;
		geodetic?:		boolean; // assumed to be false if not present...
		outputFilename?:string;
		outputFormat:	string;
		layers:			ILayer[];
		pages:			IPage[];
		legends:		ILegend[];
		app: 			string;
		dpi:			number;
	}

	export type LayerType = 'WMS' | 'WMTS' | 'VECTOR';

	export interface ILayer {
		opacity?:	number;
		type:		LayerType;
	}

	export interface IVectorLayer extends ILayer {
		geoJson: 		object;
		styleProperty?:	string|object;
		styles?: 		object;
		name?:			string;
	}

	export interface IWMSLayer extends ILayer {
		baseURL:		string;
		customParams?:	object;
		layers:			string[];
		styles?:		{};
		format:			string;
		useNativeAngle?:boolean; // defaults to false
	}

	export type WMTSVersion = '1.0.0';

	export type WMTSRequestEncoding = 'REST' | 'KVP';

	export interface WMTSMatrix {
		identifier:		string;
		matrixSize:		[number, number];
		resolution:		number;
		tileSize:		[number, number];
		topLeftCorner:	[number, number];
	}

	export interface IWMTSStandardLayer	extends ILayer {
		baseURL:		string; // the ‘ResourceURL’ available in the WMTS capabilities.
		customParams?:	object; // (Optional) Map, additional URL arguments
		layer:			string;	//  (Required) the layer name
		version:		WMTSVersion; // (Required) 1.0.0
		requestEncoding:WMTSRequestEncoding; // (Required) REST or KVP
		style:			string; // (Required) the style name
		dimensions?:	string[]; //  (Optional) list of dimensions names
		params?:		object; //  (Optional) dictionary of dimensions name (capital) => value
		matrixSet:		string; // (Required) the name of the matrix set
		matrixIds:		WMTSMatrix[]; // (Required) array of matrix ids
		format?:		string; // required if requestEncoding is KVP
	}

	/**
	 * two types of WMTS in map fish, simple implies all top left corners
	 * of the matrices are equal
	 */
	export interface IWMTSSimpleLayer extends ILayer {
		baseURL:		string;
		layer:			string;
		version:		WMTSVersion;
		requestEncoding:WMTSRequestEncoding;
		tileOrigin:		[number, number];
		tileSize:		number;
		extension:		string;
		resolutions:	number[];
		style:			string;
		tileFullExtent:	[number, number, number, number]|Extent;
		zoomOffset:		number;
		dimensions?:	string[];
		params?:		object;
		formatSuffix:	string;
	}

	// TODO - implement more layer formats....

	export interface IPage {
		mapTitle?:	string;
		center?:	Coordinate|[number, number];
		scale?:		number;
		scaleName?: string;
		bbox?:		[number, number, number, number]|Extent;
		rotation:	number;
		dpi?:		number;
		geodetic?:	boolean;
	}

	export interface ILegendClass {
		name:	string;
		icon:	string;
		iconBeforeName:	boolean;
	}

	export interface ILegend {
		name:	string;
		classes:	ILegendClass[];
	}

	export function encodeWMTS(source : WMTS) : IWMTSStandardLayer {
		console.log(source.get('wmtsOptions'));
		console.log(source.get('wmtsCapabilities'));

		if (source.get('printOptions')) {
			return source.get('printOptions');
		}

		return null;

		// need to ensure that we configure the WMTS request so that it has the same projection as
		// the other layers used in the request
		// disabled for now because the LINZ boundaries layer, in NZTM2000, is broken.
		/*
		try {
			// let tileGrid = source.getTileGrid();
			let options = source.get('wmtsOptions');
			let layerService : LayerService = source.get('layerService');
			let capabilities = source.get('wmtsCapabilities');

			if (!layerService || !capabilities || !options) return null;

			let tileMatrixSet = layerService.attributes.TileMatrixSet;

			let wmtsLayer = capabilities.Contents.Layer.filter((l) => l.Identifier == layerService.layerName);
			let tms = capabilities.Contents.TileMatrixSet.filter((tms) => tms.Identifier == tileMatrixSet);

			if (!wmtsLayer.length || !tms.length) return null;

			return {
				type: 'WMTS',
				opacity: 1.0,
				baseURL: options.urls[0].replace('{style}', options.style).replace(/{/g, "%7B").replace(/}/g, "%7D"),
				dimensions: [],
				layer: layerService.layerName,
				requestEncoding: options.requestEncoding,
				style: options.style,
				version: '1.0.0',

				matrixSet: tileMatrixSet,
				matrixIds: tms[0].TileMatrix.map((tm) => {
					return {
						identifier:		tm.Identifier,
						matrixSize:		[tm.MatrixWidth, tm.MatrixHeight],
						resolution:		tm.ScaleDenominator,
						tileSize:		[tm.TileWidth, tm.TileHeight],
						topLeftCorner:	tm.TopLeftCorner
					}
				})
			}

		} catch (ex) {
			console.warn(ex);
		}


		return null;
		*/
	}

	function encodeItemWMSLayerService(item : L.tree.Item, opacity : number, queryString : IQueryString): IWMSLayer{
		let layerService = item.layerService;
		let customParams = {};
		if(item.parent && item.parent.layerType == 'SCI_GROUP') {
			// this is a class layer...
			// customParams['CLASS'] = item.parent.CL
			layerService = item.parent.layerService;
			customParams['TRANSPARENT'] = 'true';
			let CLASS = layerService.CLASS.filter((cls) => cls.id == item.classId);
			if (CLASS.length) {
				customParams['CLASS'] = CLASS[0].param + 1;
			}
		} else if (item.layerType == 'SCIENCE' && item.layerService.CLASS) {
			customParams['CLASS'] = item.layerService.CLASS
				.map((cls) => cls.param + 1).join(',')
		}

		if (!layerService) {
			return null;
		}

		let print = layerService.print;

		let layers = (print && print.layers) || layerService.params.layers;

		let baseURL = (print && print.url) || layerService.url;
		let format = "image/svg+xml";
		let decodedURL = queryString.parseKeyValue(baseURL);
		let formatInURL = decodedURL['format'];
		if (formatInURL) {
			format = formatInURL;
		}

		return <IWMSLayer> {
			type:	'WMS',
			baseURL,
			layers,
			customParams,
			format,
			singleTile : false,
			legend: false, // layerService.legend,
			opacity,
			styles: [""],
			name: layerService.description
		};
	}

	/*
	function encodeWMSLayerService(layerService : LayerService, opacity : number, queryString : IQueryString): IWMSLayer{
		if (!layerService) {
			return null;
		}
		let url = layerService.print.url || layerService.url;
		let format = "image/svg+xml";
		let decodedURL = queryString.parseKeyValue(url);
		let formatInURL = decodedURL['format'];
		if (formatInURL) {
			format = formatInURL;
		}

		let layers = (layerService.print && layerService.print.layers) || layerService.params.layers;

		return <IWMSLayer> {
			type:	'WMS',
			baseURL: url,
			layers: layers,
			format: format,
			singleTile : false,
			legend: false, // layerService.legend,
			opacity: opacity,
			styles: [""],
			name: layerService.description
		};
	}
	*/

	/*
	export function encodeOpenLayersWMS(layer : TileLayer, src : TileWMS, queryString : IQueryString) : IWMSLayer {
		let layerService : LayerService = src.get('layerService');
		if (!layerService) return null;
		return encodeWMSLayerService(layerService, layer.getOpacity(), queryString);
	}
	*/

	function addStyle(geoJson: object, styleName: string, styleValue: string) {
		geoJson['properties'] = geoJson['properties'] || {};
		geoJson['properties'][styleName] = styleValue;


		if (geoJson['type'] && geoJson['type'] == 'FeatureCollection' && geoJson['features']) {
			geoJson['features'].forEach((f) => addStyle(f, styleName, styleValue));
		}
	}

	type StyleDefiniton = Partial<Record<Type, any>>;

	const geoMap: { [key: string]: Type } = {
		"Point": 'Point',
		"MultiPoint": 'Point',
		"LineString": 'LineString',
		"MultiLineString": 'LineString',
		"Polygon": 'Polygon',
		"MultiPolygon": 'Polygon',
		"GeometryCollection": 'GeometryCollection'
	}

	function addCustomStyle(geoJson: GeoJSONFeature|GeoJSONFeatureCollection, styleProperty: string, styleDefinition: StyleDefiniton) {
		if (geoJson.type === 'Feature') {
			geoJson.properties = geoJson.properties || {};
			const geometryType = geoJson.geometry && geoJson.geometry.type;
			geoJson.properties[styleProperty] = <Type> (geometryType ? geoMap[geometryType] : 'Polygon');
		} else if (geoJson.type == 'FeatureCollection' && Array.isArray(geoJson.features)) {
			geoJson.features.forEach(f => addCustomStyle(f, styleProperty, styleDefinition));
		}
	}

	function encodeStyleDefinition(styleDefinition: StyleDefiniton) {
		const styles: StyleDefiniton = {};

		const polyStyle = styleDefinition['Polygon'];
		if (polyStyle) {
			const fill = Color(polyStyle.fill.color);
			const strokeColor = Color(polyStyle.stroke.color);
			styles['Polygon'] = {
				fillColor: fill.hex(),
				fillOpacity: fill.opacity,
				strokeColor: strokeColor.hex(),
				strokeOpacity: strokeColor.opacity,
				strokeWidth: polyStyle.stroke.width
			}
		}

		const lineStyle = styleDefinition['LineString'];
		if (lineStyle) {
			const strokeColor = Color(lineStyle.stroke.color);
			styles['LineString'] = {
				strokeColor: strokeColor.hex(),
				strokeOpacity: strokeColor.opacity,
				strokeWidth: lineStyle.stroke.width
			}
		}

		const pointStyle = styleDefinition['Point'];
		if (lineStyle) {
			const image = pointStyle.image;
			const fill = Color(image.fill.color);
			const strokeColor = Color(image.stroke.color);
			styles['Point'] = {
				fillColor: fill.hex(),
				fillOpacity: fill.opacity,
				strokeColor: strokeColor.hex(),
				strokeOpacity: strokeColor.opacity,
				strokeWidth: image.stroke.width,
				graphicName: (image.kind || "circle").toLowerCase(),
				pointRadius: image.radius
			}
		}

		return styles;
	}

	interface EncodeVectorOptions {
		vectorFilter?: (f: Feature<Geometry>) => boolean;
		node?: L.tree.Item;
	}

	const defaultStyles = {
		'1' : {
			fillColor: '#CCCCCC',
			fillOpacity: 0.4,
			strokeColor: '#FF3F3F',
			strokeWidth: 3
		}
	};

	export function encodeVector(src : VectorSource<Geometry>, {vectorFilter, node}: EncodeVectorOptions) : IVectorLayer {
		if (!src.getFeatures().length) {
			return null;
		}
		const styleDefinition = node && node.styleDefinition;
		const geojson = new GeoJSON();
		let features = src.getFeatures();
		if (vectorFilter) features = features.filter(vectorFilter);

		const styleProperty = '__style';

		const encodedGeom = <object> geojson.writeFeaturesObject(features);

		(<GeoJSON.FeatureCollection> encodedGeom).features.forEach(f => {
			f.properties = {};
		});

		if (styleDefinition) {
			addCustomStyle(encodedGeom as GeoJSONFeatureCollection, styleProperty, styleDefinition)
		} else {
			addStyle(encodedGeom, styleProperty, '1');
		}

		const styles = styleDefinition ? encodeStyleDefinition(styleDefinition) : defaultStyles;

		return {
			'type': "VECTOR",
			geoJson : encodedGeom,
			styles,
			styleProperty: styleProperty
		};
	}

	function notNull<T>(t : T): boolean {
		return t !== null && t !== undefined;
	}

	function encodeLegendURL(baseURL: string, icon: string, queryString : IQueryString) : string {
		let startOfQ = baseURL.indexOf('?');
		let urlQString = baseURL.substring(startOfQ+1);

		let urlParams = {};

		if (startOfQ !== -1 && urlQString) {
			baseURL = baseURL.substring(0, startOfQ+1);
			let params = queryString.parseKeyValue(urlQString);
			Object.keys(params).forEach((k) => urlParams[k.toUpperCase()] = params[k].replace(/\+/g, ' '));

			if (urlParams['MAP.IMAGETYPE'] !== 'svg' && !urlParams['FORMAT']) {
				urlParams['FORMAT'] = 'image/' + urlParams['MAP.IMAGETYPE'];
			}
		}

		let defaultParams = {
			REQUEST: 'GetLegendGraphic',
			EXCEPTIONS: 'application/vnd.ogc.se_xml',
			ICON: icon,
			FORMAT: 'image/svg+xml',
			MODE:	'legendicon',
			'MAP.IMAGETYPE':	'svg'
		};

		Object.keys(defaultParams).forEach((k) => {
			if (urlParams[k] === undefined) {
				urlParams[k] = defaultParams[k];
			}
		});

		return baseURL + queryString.toKeyValue(urlParams);
	}

	export function nodeToLegend(node: L.tree.Item, queryString : IQueryString, classConfs : any[]) : ILegend {
		let layerService = node.layerService;
		if (!layerService) return null;

		let print = layerService.print;
		let legendURL = print && print.legendUrl;
		if (legendURL && node.layerType == 'SCI_GROUP') {
			return {
				name: node.name,
				classes: node.children
                    .filter((c) => c.checked)
                    .map((child : L.tree.Item) => {
                        let classId = child.classId;
                        let CLASS = (layerService.CLASS || []).filter((c) => c.id == classId);
                        if (!CLASS.length) return null;

                        let icon = (print.legendsLayers && print.legendsLayers.length && print.legendsLayers[0])
                                || (print.layers && print.layers.length && print.layers[0])
                                || (CLASS.length && CLASS[0].layerName)
                                || layerService.layerName;

                        if (!icon) {
                            return null;
                        }

                        icon = icon+','+(CLASS[0].param);
                        return {
                            name:	child.name,
                            icon: encodeLegendURL(legendURL, icon, queryString),
                            iconBeforeName:	true
                        }
				    }).filter(notNull)
			}
		} else if (legendURL && (node.layerType == 'SCIENCE' || node.layerType == 'SCI_GROUP_CLASS_UNCHECKABLE')) {
			let layerId = layerService.id;
			if (classConfs && classConfs.length) {
				let relevantClasses = uniqueBy(
                    classConfs
                        .filter((c) => c.attributes && c.attributes.layerConfigurationId == layerId.toString()),
                    cls => cls.id
                );

				return {
					name : node.name,
					classes: relevantClasses.filter((c) => c.legendOn).map((c) => {
						let icon = c.layerName + ',' + c.param;
						return {
							name: c.shortName,
							icon: encodeLegendURL(legendURL, icon, queryString),
							iconBeforeName: true
						};
					})
				}
			}
		}

		return null;
	}

	export function encodeLegends(layers: L.tree.Item[], queryString : IQueryString, classConfs : any) : ILegend[] {
        return layers.map((l) => nodeToLegend(l, queryString, classConfs)).filter(notNull);
	}

	function mergeLayers (layers : ILayer[]): ILayer[] {
		return layers.reduce((acc : ILayer[], value : ILayer) : ILayer[] => {
			let url = value['baseURL'];
			let layerType = value.type;
			if (layerType == 'WMS' && url && acc.length) {
				let prev = acc[acc.length - 1];
				if (prev['name'] == value['name'] && prev['baseURL'] == url) {
					prev['layers'] = uniqueBy(prev['layers'].concat(value['layers']), (i) => i);

					let prevParams = prev['customParams'];
					let params = value['customParams'];
					if (prevParams && prevParams['CLASS'] !== undefined && params && params['CLASS'] !== undefined) {
						prevParams['CLASS'] = prevParams['CLASS'] + ',' + params['CLASS'];
					}
				} else {
					acc.push(value)
				}
			} else {
				acc.push(value);
			}

			return acc;
		}, []);
	}

	export function encodeNode(item : L.tree.Item, queryString : IQueryString, vectorFilter: Predicate<Feature<Geometry>> = undefined) : ILayer {
		let olLayer = item.layer;
		let src = olLayer && olLayer.getSource();
		let layerService = item.layerService || (src ? src.get('layerService') : null);

		try {
			if (item.parent && item.parent.layerType == L.layer.Type.GROUP) {
				return encodeItemWMSLayerService(item, olLayer.getOpacity(), queryString);
			}

			if (src instanceof TileWMS || src instanceof ImageWMS) {
				return encodeItemWMSLayerService(item, olLayer.getOpacity(), queryString);
				// return encodeWMSLayerService(layerService, olLayer.getOpacity(), queryString)
			} else if (src instanceof WMTS) {
				if (layerService && layerService.print) {
					return encodeItemWMSLayerService(item, olLayer.getOpacity(), queryString);
				}
				return encodeWMTS(src);
			} else if (src instanceof VectorSource) {
				return encodeVector(src, { node: item, vectorFilter });
			}
		} catch (err) {
			console.warn(err);
		}

		return null;
	}

	export function layerTreeEncode(layers : L.tree.Item[], queryString : IQueryString, vectorFilter: Predicate<Feature<Geometry>>) : ILayer[] {
		let visibleLayers = getVisibleLayers(layers).filter((n) => n && !n.isCustom).reverse();
		// let checkedLayers = layers.map(L.tree.getCheckedNodes).reduce((acc, nodes) => acc.concat(nodes), []);
		return visibleLayers
			.map((l) => encodeNode(l, queryString, vectorFilter))
			.filter(notNull);
	}

	type Predicate<T> = (t: T) => boolean;

	const and = <T> (p: Predicate<T>, q: Predicate<T>) => (t: T) => {
		return p(t) && q(t);
	};

	export function encodeVectorLayers(vectorLayers : VectorLayer<VectorSource<Geometry>>[], vectorFilter: (f: Feature<Geometry>) => boolean = null) : IVectorLayer[] {
		return vectorLayers.map((l) => l.getSource()).map(s => encodeVector(s, {vectorFilter})).filter(notNull);
	}

	const TEN_MEGABYTES = 10000000;

	export function layerTreeToRequest(layers : L.tree.Item[],
									   map : OlMap,
									   mapTitle: string,
									   app: string,
									   layout: ILayout,
									   outputFormat: string,
									   center: Coordinate,
									   scale: INameValue,
									   queryString : IQueryString,
									   classConfs : any[],
									   vectorLayers : VectorLayer<VectorSource<Geometry>>[] = [],
									   vectorFilter: (f: Feature<Geometry>) => boolean = null): IMapFishRequest {
		const view = map.getView();
		const projection = view.getProjection();

		const extent = pageExtent(center, parseInt(scale.value), layout);

		const extentFilter: Predicate<Feature<Geometry>> = f => intersects(extent, f.getGeometry().getExtent());

		vectorFilter = vectorFilter ? and(vectorFilter, extentFilter) : extentFilter;

		const result = {
			app: app,
			dpi: 72,
			layers: mergeLayers(layerTreeEncode(layers, queryString, extentFilter)).concat(encodeVectorLayers(vectorLayers, vectorFilter)),
			//uniqueBy<ILayer>(layerTreeEncode(layers, queryString), (l) => l.layers[0]),
			layout: layout.name,
			srs: projection.getCode(),
			units: projection.getUnits(),
			outputFormat: outputFormat,
			legends: encodeLegends(getVisibleLayers(layers), queryString, classConfs).filter(notNull).reverse(),
			pages: [{
				center: center,
				scale: parseFloat(scale.value),
				scaleName: scale.name,
				mapTitle: mapTitle,
				rotation: 0
			}]
		};

		if (JSON.stringify(result).length > TEN_MEGABYTES) {
			throw new Error('Request too large');
		}

		return result;
	}
}
